import { computed } from 'vue';
import { SEARCH_KEYS } from '@/utils/searchKeys.js';

export function useFilterArray(sourceRef, searchTextRef, keyRef) {
  const filtered = computed(() => {
    const term = (searchTextRef.value || '').trim().toLowerCase();
    if (!term) return sourceRef.value;

    const keys =
      SEARCH_KEYS[keyRef] ||
      (sourceRef.value?.length ? Object.keys(sourceRef.value[0]) : []);

    return sourceRef.value.filter((item) =>
      keys.some((key) => {
        const value = item[key];

        if (value == null) return false;

        // if value is an array of strings
        if (Array.isArray(value) && value.every((v) => typeof v === 'string')) {
          return value.some((v) => v.toLowerCase().includes(term));
        }

        // if value is an array of objects
        if (Array.isArray(value) && value.every((v) => typeof v === 'object')) {
          return value.some((obj) =>
            Object.values(obj)
              .map((v) => String(v).toLowerCase())
              .some((str) => str.includes(term))
          );
        }

        // normal
        return String(value).toLowerCase().includes(term);
      })
    );
  });

  return { filtered };
}